// FDI notation tooth sets for Adult (permanent) and Pediatric (primary/deciduous)

export const ADULT = {
  UPPER_RIGHT: [18, 17, 16, 15, 14, 13, 12, 11],
  UPPER_LEFT: [21, 22, 23, 24, 25, 26, 27, 28],
  LOWER_LEFT: [38, 37, 36, 35, 34, 33, 32, 31],
  LOWER_RIGHT: [41, 42, 43, 44, 45, 46, 47, 48],
};

export const PEDIATRIC = {
  UPPER_RIGHT: [55, 54, 53, 52, 51],
  UPPER_LEFT: [61, 62, 63, 64, 65],
  LOWER_LEFT: [75, 74, 73, 72, 71],
  LOWER_RIGHT: [81, 82, 83, 84, 85],
};

export const getTeethSet = (chartType) =>
  chartType === "pediatric" ? PEDIATRIC : ADULT;

// Utility: given a tooth number (string or number), guess chart type
export const chartOf = (tooth) => {
  const n = parseInt(tooth, 10);
  if (n >= 51 && n <= 85) return "pediatric";
  return "adult";
};
